import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutNote, checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-157" data-mp="2jkxhhce7w0y1">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-158" data-mp="1vtic1ar593ik">
        {showUrgency && <CountdownPanel data-id="element-159" data-mp="1rsgcstx88rgl" />}

        <div className="mx-auto mt-10 max-w-4xl rounded-xl bg-white p-7 shadow-lg ring-2 ring-blue-600 md:p-10" data-id="element-160" data-mp="1rt8966ynet7x">
          {!showUrgency && <p className="text-center text-sm font-bold uppercase tracking-widest text-blue-600" data-id="element-161" data-mp="25q4ujsvzzihf">
              {offer.eyebrow}
            </p>}
          <p className={`text-center text-xl font-extrabold uppercase tracking-tight text-gray-900 md:text-2xl ${showUrgency ? '' : 'mt-3'}`} data-id="element-162" data-mp="3h6lcbsv0yb7g">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg font-semibold text-blue-700" data-id="element-163" data-mp="3vz72a1ghsvrl">{offer.system}</p>
          <p className="mx-auto mt-4 max-w-2xl text-center text-gray-600" data-id="element-164" data-mp="4rktxvitw54e">{offer.summary}</p>

          <div className="mx-auto mt-8 max-w-xl" data-id="element-165" data-mp="9srxtjhuok5s">
            <p className="text-sm font-bold text-gray-900" data-id="element-166" data-mp="er1ujyj83sti">{offer.includesLabel}</p>
            <ul className="mt-3 grid gap-4 text-left sm:grid-cols-2" data-id="element-167" data-mp="3d8z3fvjtsrh7">
              {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-168" data-mp="3i7iq5y68u7am">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-169" data-mp="3i5phyefzff0i">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="3ry3m1duj8xpu" />
                  </span>
                  <span className="text-gray-900" data-id="element-171" data-mp="2uizjfn2ue2kn">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mt-10 text-center" data-id="element-172" data-mp="2zg9djg16f2et">
            <p className="text-lg text-gray-400" data-id="element-173" data-mp="2rguzve1otwdq">
              Valor regular <span className="line-through" data-id="element-174" data-mp="2rf1tlzuzle69">{offer.listPrice}</span>
            </p>
            <p className="text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl" data-id="element-175" data-mp="2mh0714ycqwq1">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-gray-500" data-id="element-176" data-mp="318qzitjf9uk2">ARS</span>
            </p>
            <p className="mt-3" data-id="element-177" data-mp="2w9o5s58w7are">
              <span className="inline-block rounded-md bg-emerald-50 px-3 py-1 text-sm font-bold text-emerald-700" data-id="element-178" data-mp="28hqssatpicop">
                Ahorras {offer.savings}
              </span>
            </p>
          </div>

          <div className="mt-8" data-id="element-179" data-mp="2igpuf9g21827">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-180" data-mp="2igya193karh3">
              {offer.cta}
            </CtaButton>
            <p className="mt-3 text-center text-sm text-gray-500" data-id="element-181" data-mp="2dj6f067mep8o">{checkoutNote}</p>
          </div>

          <p className="mt-4 text-center text-sm text-gray-500" data-id="element-182" data-mp="3txg4x4rigm1m">{offer.footnote}</p>
        </div>
      </div>
    </section>;
}